export default "__VITE_ASSET__CSRODrP5__"